import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ForeignTradeByProductsFilter = _resolveComponent("ForeignTradeByProductsFilter")!
  const _component_ForeignTradeByProductsBaseInfo = _resolveComponent("ForeignTradeByProductsBaseInfo")!
  const _component_ForeignTradeByProductsTable = _resolveComponent("ForeignTradeByProductsTable")!
  const _component_AggregatedPageWrapper = _resolveComponent("AggregatedPageWrapper")!

  return (_ctx.isAccessAllowed)
    ? (_openBlock(), _createBlock(_component_AggregatedPageWrapper, {
        key: 0,
        title: "Внешняя торговля субъекта Российской Федерации в разрезе товаров",
        exportConfig: _ctx.getExportConfig
      }, {
        filter: _withCtx(() => [
          _createVNode(_component_ForeignTradeByProductsFilter, {
            onSearchFilter: _ctx.searchFilter,
            onUpdateFilter: _ctx.updateFilter,
            defaultFilter: _ctx.defaultFilter,
            readonlyPermissionCode: _ctx.getPermissions.build
          }, null, 8, ["onSearchFilter", "onUpdateFilter", "defaultFilter", "readonlyPermissionCode"])
        ]),
        "base-info": _withCtx(() => [
          _createVNode(_component_ForeignTradeByProductsBaseInfo, { filter: _ctx.filter }, null, 8, ["filter"])
        ]),
        table: _withCtx(() => [
          _createVNode(_component_ForeignTradeByProductsTable, { filter: _ctx.filter }, null, 8, ["filter"])
        ]),
        _: 1
      }, 8, ["exportConfig"]))
    : _createCommentVNode("", true)
}